

































































































































































































































































import ActionBar from '@/components/action-bar/action-bar.vue';
import KendoChart from '@/components/kendo-chart/kendo-chart.vue';
import { DIRECT_SALES_ROUTES } from '@/modules/direct-sales/router';
import { numeralService, httpService, traceLogAccess } from '@/services';
import _ from 'lodash';
import moment from 'moment';
import numeral from 'numeral';
import { Component, Vue } from 'vue-property-decorator';
import { AxiosError, AxiosResponse } from 'axios';
import { CONFIG } from '@/config';
import PageLoader from '@/components/page-loader/page-loader.vue';
import KendoDropdown from '@/components/kendo-dropdown/kendo-dropdown.vue';
import { Action, Getter } from 'vuex-class';
import { PageContextName } from '@/enums';

@Component({
  components: {
    ActionBar,
    KendoChart,
    PageLoader,
    KendoDropdown
  }
})
export default class DirectSalesProductHistoryPage extends Vue {
  public numeral = numeral;
  public getMax = numeralService.getMax;
  public getMin = numeralService.getMin;

  public state: any = {
    data: [],
    dataProposals: [],
    dataConsumersSize: [],
    families: [],
    models: [],
    stores: [],
    groups: [],
    storeSelected: {},
    groupSelected: {},
    areaColumnOrder: 'createdAt',
    selectedArea: 0,
    dateInitial: moment()
      .subtract(14, 'days')
      .format('DD/MM/YYYY'),
    dateFinal: moment().format('DD/MM/YYYY'),
    idFamily: 0,
    idModel: 0,
    user: {},
    dataSales: [],
    salesChannel: [],
    selectedSalesChannel: {},
    idSalesChannel: 0
  };

  public nameOfProposalChart = 'Evolução das Propostas Comerciais';

  public nameOfDemarcatedAreaChart = ' Qt. Clientes Toyota na Área Demarcada ';

  public areaColumnOrderDataSource = [
    {
      text: 'Area',
      value: 'areaName'
    }
  ];

  public get historyChart() {
    return _(this.state.data)
      .filter((item: any) => item.idArea === this.state.selectedArea)
      .map((item: any) =>
        _(item.history)
          .orderBy('month')
          .orderBy('year')
          .value()
      )
      .flatten()
      .takeRight(12)
      .value();
  }

  public get historyHighlight() {
    const history = _(this.state.data)
      .filter((item: any) => item.idArea === this.state.selectedArea)
      .map((item: any) =>
        _(item.history)
          .orderBy('month')
          .orderBy('year')
          .value()
      )
      .flatten()
      .takeRight(2)
      .value();

    const last = history.length - 1;
    const historyPeriods = _.find(this.historyList, (item: any) => item.idArea === this.state.selectedArea).history;

    return {
      basePrice: {
        value: history[last].basePrice,
        diff: history[last].basePrice / history[last - 1].basePrice - 1
      },
      salePrice: {
        value: history[last].salePrice,
        diff: history[last].salePrice / history[last - 1].salePrice - 1
      },
      discount: {
        value: history[last].discount,
        diff: history[last].discount / history[last - 1].discount - 1
      },
      averageSalePrice: {
        value: historyPeriods[1].salePrice,
        diff: historyPeriods[1].salePrice / historyPeriods[0].salePrice - 1
      }
    };
  }

  public get historyList() {
    return _(this.state.data)
      .map((item: any) => {
        let counter = 0;
        let period = -1;
        let startDate: string;
        let endDate: string;
        const history = _(item.history)
          .orderBy('month')
          .orderBy('year')
          .reverse()
          .groupBy((history: any) => {
            if (counter++ % 12 === 0) {
              const date = moment(`01${numeral(history.month).format('00')}${history.year}`, 'DDMMYYYY');
              period++;
              endDate = date.format('MMM/YYYY').toUpperCase();
              startDate = date
                .subtract(1, 'year')
                .add(1, 'month')
                .format('MMM/YYYY')
                .toUpperCase();
            }

            return `${startDate} a ${endDate}`;
          })
          .map((values: any[], key: string) => ({
            period: key,
            basePrice: _.sumBy(values, 'basePrice') / values.length,
            salePrice: _.sumBy(values, 'salePrice') / values.length,
            discount: _.sumBy(values, 'discount') / values.length
          }))
          .reverse()
          .value();
        return { ...item, ...{ history } };
      })
      .value();
  }

  public getSales() {
    if (this.state.idModel == 0) {
      return;
    }

    httpService.http
      .get(
        `${CONFIG.URL.NEODASH_API}/api/directsales/proposal/models/${this.state.storeSelected.value}/${
          this.state.idModel
        }/${this.FormataStringData(this.state.dateInitial)}/${this.FormataStringData(this.state.dateFinal)}`
      )
      .then((res: AxiosResponse) => {
        if (res.data) {
          this.state.dataSales = _([
            {
              value: numeral(res.data.averagevaluePractedAOV).value(),
              text: 'AOV ' + res.data.nameAOV,
              order: 2,
              discount: numeral(res.data.averageDiscountPractedAOV).value() / 100
            },
            {
              value: numeral(res.data.averagevaluePractedRegion).value(),
              text: res.data.nameRegion,
              order: 3,
              discount: numeral(res.data.averageDiscountPractedRegion).value() / 100
            },
            {
              value: numeral(res.data.averagevaluePractedRegionale).value(),
              text: res.data.nameRegionale,
              order: 1,
              discount: numeral(res.data.averageDiscountPractedRegionale).value() / 100
            },
            {
              value: numeral(res.data.averagevaluePractedStore).value(),
              text: res.data.nameStore,
              order: 4,
              discount: numeral(res.data.averageDiscountPractedStore).value() / 100
            }
          ])
            .orderBy((item: any) => {
              item.order;
            })
            .value();
        }
      })
      .catch((err: AxiosError) => console.log(err.message));
  }

  public getNameValuePracted(order) {
    if (this.state.dataSales.length > 0) {
      return this.state.dataSales.filter(function(f) {
        return f.order == order;
      })[0].text;
    }
    return '';
  }

  public getValuePracted(order) {
    if (this.state.dataSales.length > 0) {
      return this.state.dataSales.filter(function(f) {
        return f.order == order;
      })[0].value;
    }
    return 0;
  }

  public getDiscountPracted(order) {
    if (this.state.dataSales.length > 0) {
      return this.state.dataSales.filter(function(f) {
        return f.order == order;
      })[0].discount;
    }
    return 0;
  }

  public setStore(idStore: any) {
    this.state.dataProposals = [];
    this.state.dataConsumersSize = [];
    this.state.storeSelected = {};

    if (idStore == 0) {
      return;
    }

    this.state.storeSelected = _.filter(this.state.stores, f => f.value == idStore)[0];

    if (this.state.storeSelected.value) {
      this.getProposal();
      this.getPMG();
    }
  }

  public getProposal() {
    httpService.http
      .get(
        `${CONFIG.URL.NEODASH_API}/api/directsales/proposal/proposals/${this.FormataStringData(
          this.state.dateInitial
        )}/${this.FormataStringData(this.state.dateFinal)}/${this.state.storeSelected.value}`
      )
      .then((res: AxiosResponse) => {
        if (res.data) {
          this.state.dataProposals = _(res.data)
            .map(m => ({
              value: m.length,
              text: m.expired ? 'EXPIROU' : m.situation,
              idSituation: m.expired ? 100 : m.idSituation,
              orderSituation: m.orderSituation
            }))
            .groupBy((prop: any) => prop.idSituation)
            .map(m => ({
              value: m.length,
              text: m[0]['text'],
              idSituation: m[0]['idSituation'],
              orderSituation: m[0]['orderSituation']
            }))
            .orderBy('orderSituation')
            .value();
        }
      })
      .catch((err: AxiosError) => console.log(err.message));
  }

  public getPMG() {
    httpService.http
      .get(`${CONFIG.URL.NEODASH_API}/api/directsales/consummer/salesMarkedArea/${this.state.storeSelected.value}`)
      .then((res: AxiosResponse) => {
        if (res.data) {
          this.state.dataConsumersSize = _(res.data)
            .orderBy('channelName')
            .value();

          this.state.salesChannel = _(res.data)
            .map((m: any) => ({ text: m.channelName, value: m.idChannel }))
            .orderBy('channelName')
            .value();

          this.state.selectedSalesChannels = this.state.salesChannel[0];
          this.state.idSalesChannel = this.state.salesChannel[0].value;
        }
      })
      .catch((err: AxiosError) => console.log(err.message));
  }

  public get getPMGSalesChannel() {
    const sizesConsumersSalesChannel = _(this.state.dataConsumersSize)
      .filter((f: any) => {
        return f.idChannel == this.state.idSalesChannel;
      })
      .value()[0];
    if (sizesConsumersSalesChannel) {
      return [
        {
          channelName: sizesConsumersSalesChannel.channelName,
          text: 'Pequeno',
          value: sizesConsumersSalesChannel.small
        },
        {
          channelName: sizesConsumersSalesChannel.channelName,
          text: 'Médio',
          value: sizesConsumersSalesChannel.medium
        },
        { channelName: sizesConsumersSalesChannel.channelName, text: 'Grande', value: sizesConsumersSalesChannel.big }
      ];
    } else {
      return [];
    }
  }

  public getColorSituation(idSituation: Number) {
    switch (idSituation) {
      case 1: {
        return '#529952';
      }
      case 2: {
        return '#D8A443';
      }
      case 3: {
        return '#DD3E3E';
      }
      case 4: {
        return 'grey';
      }
      case 5: {
        return '#387DAA ';
      }
      default: {
        return '#403f3f';
      }
    }
  }

  public FormataStringData(data: string) {
    let dia = data.split('/')[0];
    let mes = data.split('/')[1];
    let ano = data.split('/')[2];

    return ano + '-' + ('0' + mes).slice(-2) + '-' + ('0' + dia).slice(-2);
  }

  public goToCreateProposal() {
    this.$router.push({
      name: DIRECT_SALES_ROUTES.PROPOSALS_CREATE
    });
  }

  public getChartProposalColor(e) {
    return this.getColorSituation(e.dataItem.idSituation);
  }

  public get clientAreas() {
    const areas = _(this.state.data)
      .filter((item: any) => item.idArea !== 0)
      .map((item: any) => ({ text: item.areaName, value: item.idArea }))
      .uniqBy('text')
      .orderBy('text')
      .value();

    return [{ text: 'NACIONAL', value: 0 }, ...areas];
  }

  public getStoresUser() {
    httpService.http
      .get(`${CONFIG.URL.NEODASH_API}/api/directsales/proposal/stores/${this.state.groupSelected.value}`)
      .then((res: AxiosResponse) => {
        const stores: any[] = _(res.data)
          .map(d => ({
            value: d.id,
            text: d.name
          }))
          .value();

        if (stores.length === 1) {
          this.state.storeSelected = stores[0];

          this.getProposal();
          this.getPMG();
        }

        this.state.stores = _(stores)
          .orderBy('text')
          .value();
      })
      .catch((err: AxiosError) => console.log(err.message));
  }

  public getGroupsUser() {
    httpService.http
      .get(`${CONFIG.URL.NEODASH_API}/api/directsales/proposal/groups/`)
      .then((res: AxiosResponse) => {
        const groups: any[] = _(res.data)
          .map(d => ({
            value: d.value,
            text: d.text
          }))
          .orderBy('text')
          .value();

        if (groups.length === 1) {
          this.state.groupSelected = groups[0];
          this.getStoresUser();
        }

        this.state.groups = groups;
      })
      .catch((err: AxiosError) => console.log(err.message));
  }

  public setGroup(groupValue) {
    this.state.stores = [];
    this.state.storeSelected = {};

    if (groupValue == 0) {
      this.state.groupSelected = {};
      return;
    }

    this.state.groupSelected = _.filter(this.state.groups, f => f.value == groupValue)[0];
    this.getStoresUser();
  }

  public created() {
    this.state.data = _.map(['NACIONAL', 'AOV', 'REGIONAL', 'AREA DEMARCADA'], (name: string, i: number) => ({
      id: i,
      areaName: name,
      idArea: i,
      history: _.map(_.range(0, 24), (i: number) => ({
        month: (i % 12) + 1,
        monthName: (moment.localeData() as any)._monthsShort[i % 12].toUpperCase(),
        year: i < 12 ? 2016 : i < 24 ? 2017 : 2018,
        basePrice: _.random(60000, 70000),
        salePrice: _.random(60000, 70000),
        discount: _.random(0.05, 0.2, true)
      }))
    }));
  }

  public setDateInit(data) {
    this.state.dateInitial = data;
    //this.getProposal();
    this.getSales();
  }

  public goToProposals() {
    this.$router.push({
      name: DIRECT_SALES_ROUTES.PROPOSALS
    });
  }

  public setDateFim(data) {
    this.state.dateFinal = data;
    this.getProposal();
    this.getSales();
  }

  public goToListClients() {
    this.$router.push({
      name: DIRECT_SALES_ROUTES.LIST_CLIENTS
    });
  }

  public getUser() {
    httpService.http
      .get(`${CONFIG.URL.NEODASH_API}/api/directsales/proposal/user`)
      .then((res: AxiosResponse) => {
        this.state.user = res.data;
      })
      .catch((err: AxiosError) => console.log(err.message));
  }

  public getPDFDisponibility() {
    const parametersFormat = {
      nameReport: 'Relatorio_Disponibilidade_Veiculos',
      reportType: 1,
      typeExtensionReport: 2
    };
    httpService.httpBlob
      .post(`${CONFIG.URL.NEODASH_API}/api/directsales/politics/salesdisponibility`, parametersFormat)
      .then((res: AxiosResponse) => {
        const blob = new Blob([res.data], {
          type: 'application/pdf'
        });
        kendo.saveAs({
          dataURI: window.URL.createObjectURL(blob),
          fileName: res.headers['content-disposition'].substring(21, res.headers['content-disposition'].length)
        });
        traceLogAccess.generationTracking(PageContextName.pdfVehiclesAvailability);
      })
      .catch((err: AxiosError) => {
        console.log('Error', err);
      });
  }

  public mounted() {
    traceLogAccess.generationTracking(PageContextName.directSalesAssistant);
    this.getGroupsUser();
    this.getUser();
  }
}
